import { CORE_CHAIN } from '@constants/variables';
import { RootState } from '@state/store';


export const selectProviderNetworkCore = (state: RootState) => state.provider.networkProviders[CORE_CHAIN];
export const selectProviderNetworkOld = (state: RootState) => state.provider.networkProviders[1666600000];
export const selectProviderChainId = (state: RootState) => state.provider.chainId
export const selectProviderSwitching = (state: RootState) => state.provider.switching